import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n";

// 引入語言檔
import meta_en from "./locales/en/meta.json";
import meta_zhtw from "./locales/zh-TW/meta.json";
import tags_en from "./locales/en/tags.json";
import tags_zhtw from "./locales/zh-TW/tags.json";
import search_en from "./locales/en/search.json";
import search_zhtw from "./locales/zh-TW/search.json";

// 註冊語言檔
addMessages("en", {
  "meta": meta_en,
  "tags": tags_en,
  "search": search_en,
});

addMessages("zh-TW", {
  "meta": meta_zhtw,
  "tags": tags_zhtw,
  "search": search_zhtw,
});

// 初始化 i18n
init({
  fallbackLocale: "en",
  initialLocale: getLocaleFromNavigator(),
});
